import { TextField, styled } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import React, { useState } from "react";
import PasswordChecklist from "react-password-checklist";
import { resetPassword, confirmResetPassword } from "aws-amplify/auth";

const CustomBtn = styled(LoadingButton)(({ theme }) => ({
  color: "white",
  fontSize: "1rem",
  background:
    "linear-gradient(90deg, rgba(234,92,84,1) 0%, rgba(239,132,58,1) 42%, rgba(239,198,94,1) 100%)",
  filter:
    'progid:DXImageTransform.Microsoft.gradient(startColorstr="#ea5c54",endColorstr="#efc65e",GradientType=1)',
  marginTop: "5px",
}));

const ForgetPass = (props) => {
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState(1);
  const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const changeHandler = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    switch (name) {
      case "Username":
        setUserName(val);
        break;
      case "code":
        setCode(val);
        break;
      case "newPass":
        setPassword(val);
        break;
      case "confirmPass":
        setConfirmPass(val);
        break;
      default:
        break;
    }
  };

  // Stage 1 — send reset code to email
  const sendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const output = await resetPassword({
        username: username.toUpperCase(),
      });
      // Amplify returns where the code was delivered
      const destination =
        output.nextStep?.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE"
          ? output.nextStep.codeDeliveryDetails?.destination || "your email"
          : "your email";
      setMessage(destination);
      setStage(2);
    } catch (err) {
      alert(err.message || "Failed to send reset code. Please try again.");
    }
    setLoading(false);
  };

  // Stage 2 — confirm reset with code + new password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (confirmPass !== password) {
      alert("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await confirmResetPassword({
        username: username.toUpperCase(),
        confirmationCode: code,
        newPassword: password,
      });
      alert("Password changed successfully. Please login with your new password.");
      props.setForgetPass(false);
    } catch (err) {
      alert(err.message || "Failed to reset password. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div>
      {stage === 1 && (
        <>
          <div className="text-left">
            <h1 className="text-3xl mb-2 font-semibold">
              Forget your password?
            </h1>
            <p className="w-[85%] mb-3">
              Enter your Username below and we will send an email to reset your
              password
            </p>
          </div>
          <form onSubmit={sendCode}>
            <TextField
              id="userName"
              name="Username"
              label="Enter your Username"
              required={true}
              variant="filled"
              fullWidth
              size="small"
              onChange={changeHandler}
            />
            <CustomBtn
              type="submit"
              variant="contained"
              className="w-11/12"
              loading={loading}
            >
              Reset my password
            </CustomBtn>
          </form>
        </>
      )}

      {stage === 2 && (
        <>
          <p className="mb-2">
            We have sent a password reset code by email to {message}. Enter it
            below to reset your password.
          </p>
          <form onSubmit={handleResetPassword}>
            <div className="flex flex-col gap-2">
              <TextField
                id="code"
                name="code"
                label="Enter your code"
                required={true}
                variant="filled"
                fullWidth
                size="small"
                onChange={changeHandler}
              />
              <TextField
                id="newPass"
                name="newPass"
                label="Enter new password"
                onChange={changeHandler}
                required={true}
                variant="filled"
                fullWidth
                size="small"
              />
              <TextField
                id="confirmPass"
                name="confirmPass"
                label="Confirm password"
                required={true}
                variant="filled"
                fullWidth
                size="small"
                onChange={changeHandler}
              />
            </div>
            <CustomBtn
              type="submit"
              variant="contained"
              className="w-11/12"
              loading={loading}
            >
              Change password
            </CustomBtn>
          </form>
          <div className="w-[100%] ml-4 mt-3">
            <PasswordChecklist
              rules={[
                "capital",
                "match",
                "specialChar",
                "minLength",
                "number",
                "lowercase",
              ]}
              minLength={8}
              value={password}
              valueAgain={confirmPass}
            />
          </div>
        </>
      )}

      <div className="text-left mx-auto mt-3">
        <span
          onClick={() => props.setForgetPass(false)}
          className="underline text-blue-600 cursor-pointer"
        >
          Login here
        </span>
      </div>
    </div>
  );
};

export default ForgetPass;